import React, { createContext, useContext, useState, useCallback } from "react";
import { site } from "@/config/site";

const ConversionContext = createContext(null);

export function ConversionProvider({ children }) {
  const [formOpen, setFormOpen] = useState(false);
  const [formPrefill, setFormPrefill] = useState(null);
  const [calendlyOpen, setCalendlyOpen] = useState(false);
  const [cookieOpen, setCookieOpen] = useState(false);

  const openForm = useCallback((prefill = null) => {
    setFormPrefill(prefill);
    setFormOpen(true);
  }, [setFormPrefill, setFormOpen]);

  // No dead button: while Calendly URL is not configured, "Prendre rendez-vous"
  // opens the contact form instead.
  const openCalendly = useCallback(() => {
    if (site.calendlyUrl) {
      setCalendlyOpen(true);
    } else {
      setFormPrefill({ source: "rendez-vous" });
      setFormOpen(true);
    }
  }, [setCalendlyOpen, setFormPrefill, setFormOpen]);

  const value = {
    formOpen,
    formPrefill,
    openForm,
    closeForm: () => setFormOpen(false),
    calendlyOpen,
    openCalendly,
    closeCalendly: () => setCalendlyOpen(false),
    cookieOpen,
    setCookieOpen,
  };

  return <ConversionContext.Provider value={value}>{children}</ConversionContext.Provider>;
}

export function useConversion() {
  const ctx = useContext(ConversionContext);
  if (!ctx) throw new Error("useConversion must be used within ConversionProvider");
  return ctx;
}
